<template>
    <div>
      <productDetail />
    </div>
</template>

<script>
export default {
  components: {
    productDetail: () => import('@/components/Gracz/Sales/Product/ProductDetail')
  },
  created () {
    this.$EventBus.$emit('getPath')
    this.$EventBus.$emit('changeAppBarGracz')
    this.$EventBus.$emit('enableCartGracz')
    this.$EventBus.$on('changeNav', this.changeNav)
    if (localStorage.getItem('oneData') === null || localStorage.getItem('UserDetailSelling') === null) {
      this.$EventBus.$emit('changeAppBarPanit')
      this.$router.push({ path: '/' }).catch(() => {})
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style scoped>
.container {
  max-width: 100%;
}
</style>
